export const initialAbility = [
  {
    action: 'read',
    subject: 'admin',
  },
]

export const _ = undefined
